var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSnorkeling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 365.014,
    y2: 495.764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.727,
    x2: 163.857,
    xlinkHref: "#lg1",
    y1: 181.044,
    y2: 210.175
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.423,
    x2: 379.186,
    xlinkHref: "#lg1",
    y1: 175.511,
    y2: 216.274
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 348.704,
    y2: 460.412
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.017,
    x2: 271.564,
    xlinkHref: "#lg2",
    y1: 454.792,
    y2: 236.225
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 434.057,
    y2: 462.39
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.237,
    x2: 359.763,
    xlinkHref: "#lg1",
    y1: 198.494,
    y2: 198.494
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.062,
    x2: 243.25,
    xlinkHref: "#lg2",
    y1: 258.283,
    y2: 204.172
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 214.431,
    y2: 246.42
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.335,
    x2: 223.784,
    xlinkHref: "#lg3",
    y1: 200.116,
    y2: 200.116
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.216,
    x2: 316.665,
    xlinkHref: "#lg3",
    y1: 200.116,
    y2: 200.116
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.401,
    x2: 161.02,
    xlinkHref: "#lg2",
    y1: 400.372,
    y2: 439.304
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(-1 0 0 1 164.441 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -259.159,
    x2: -184.539,
    xlinkHref: "#lg2",
    y1: 400.372,
    y2: 439.304
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.27,
    x2: 345.734,
    xlinkHref: "#lg4",
    y1: 101.762,
    y2: 151.983
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.584,
    x2: 246.146,
    xlinkHref: "#lg4",
    y1: 58.054,
    y2: 142.227
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.48,
    x2: 80.77,
    y1: 131.329,
    y2: 86.767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.022,
    x2: 268.849,
    y1: 144.936,
    y2: 246.968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff",
    stopOpacity: 0
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.81,
    x2: 270.049,
    y1: 140.494,
    y2: 251.369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ade194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68ca44"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 220.798,
    y2: 239.705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68ca44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47a920"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.457,
    x2: 275.329,
    xlinkHref: "#lg3",
    y1: 284.498,
    y2: 311.37
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(-1 0 0 -1 510 602.409)",
    gradientUnits: "userSpaceOnUse",
    x1: 250.607,
    x2: 268.65,
    xlinkHref: "#lg3",
    y1: 306.975,
    y2: 325.018
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.195,
    x2: 186.024,
    y1: 236.765,
    y2: 294.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.765,
    x2: 117.765,
    xlinkHref: "#lg5",
    y1: 95.245,
    y2: 124.379
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.765,
    x2: 117.765,
    y1: 110.718,
    y2: 83.213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.765,
    x2: 117.765,
    xlinkHref: "#lg3",
    y1: 76.198,
    y2: 94.391
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.765,
    x2: 117.765,
    xlinkHref: "#lg5",
    y1: 124.6,
    y2: 153.734
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.122,
    x2: 259.456,
    xlinkHref: "#lg6",
    y1: 456.161,
    y2: 339.495
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg6",
    y1: 411.632,
    y2: 466.777
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 360.375c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.615-47.544 2.428-47.544 26.831v60.408c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-60.412c0-24.582-27.011-39.596-47.889-26.618z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m124.07 196.703c0-17.128 11.889-31.479 27.865-35.25 4.27-1.008 8.353 2.294 8.353 6.682v57.135c0 4.388-4.082 7.69-8.353 6.682-15.976-3.771-27.865-18.121-27.865-35.249z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.93 196.703c0-17.128-11.889-31.479-27.865-35.25-4.27-1.008-8.353 2.294-8.353 6.682v57.135c0 4.388 4.082 7.69 8.353 6.682 15.976-3.771 27.865-18.121 27.865-35.249z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m433.732 467.805h-357.464c-8.507 0-15.403-6.896-15.403-15.403 0-82.175 66.616-148.791 148.791-148.791h90.688c82.175 0 148.791 66.616 148.791 148.791 0 8.507-6.896 15.403-15.403 15.403z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.353 467.805h85.379c8.507 0 15.403-6.896 15.403-15.403 0-82.175-66.616-148.791-148.791-148.791h-90.688c-8.04 0-15.928.646-23.622 1.874z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.865 452.402c0 8.507 6.896 15.403 15.403 15.403h357.464c8.507 0 15.403-6.896 15.403-15.403 0-11.797-1.38-23.271-3.974-34.276h-380.321c-2.595 11.005-3.975 22.479-3.975 34.276z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 330.119c-57.859 0-104.763-46.904-104.763-104.763v-53.725c0-57.859 46.904-104.763 104.763-104.763 57.859 0 104.763 46.904 104.763 104.763v53.725c0 57.859-46.904 104.763-104.763 104.763z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.33 219.736c0-4.297-3.484-7.781-7.781-7.781h-19.098c-4.297 0-7.781 3.484-7.781 7.781 0 4.297-3.484 7.781-7.781 7.781h-79.625c.075 3.686.337 7.326.783 10.91l90.881 90.881c4.282.533 8.644.811 13.071.811 57.136 0 103.584-45.741 104.735-102.602h-79.624c-4.297 0-7.78-3.483-7.78-7.781z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.787 251.705h-11.575c-9.647 0-16.95-8.717-15.26-18.215l6.635-37.301h28.825l6.635 37.301c1.69 9.498-5.613 18.215-15.26 18.215z",
    fill: "url(#SVGID_9_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208.56 219.245c-8.408 0-15.225-6.816-15.225-15.225v-7.808c0-8.408 6.816-15.225 15.225-15.225 8.408 0 15.225 6.816 15.225 15.225v7.808c-.001 8.408-6.817 15.225-15.225 15.225z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.44 219.245c-8.408 0-15.225-6.816-15.225-15.225v-7.808c0-8.408 6.816-15.225 15.225-15.225 8.408 0 15.225 6.816 15.225 15.225v7.808c0 8.408-6.816 15.225-15.225 15.225z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m60.865 452.402c0 8.507 6.896 15.403 15.403 15.403h36.536v-128.35c-31.793 27.288-51.939 67.763-51.939 112.947z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.135 452.402c0 8.507-6.896 15.403-15.403 15.403h-36.536v-128.35c31.794 27.288 51.939 67.763 51.939 112.947z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m355.636 163.217h-54.196v-91.33h12.941c36.612 0 66.292 29.68 66.292 66.292.001 13.828-11.209 25.038-25.037 25.038z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.67 163.217h-95.649c-32.727 0-59.257-26.53-59.257-59.257v-40.68c0-11.645 9.44-21.085 21.085-21.085h133.821c33.419 0 60.511 27.092 60.511 60.511 0 33.419-27.091 60.511-60.511 60.511z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.51 61.487h-11.655c-.05.592-.091 1.187-.091 1.793v40.68c0 32.727 26.53 59.257 59.257 59.257h54.218z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m339.238 153.954h-84.238-84.238c-17.153 0-31.058 12.689-31.058 28.342v27.787c0 15.653 13.905 28.342 31.058 28.342h50.234c8.311 0 15.955-4.151 19.92-10.817l5.125-8.617c3.858-6.487 14.062-6.487 17.92 0l5.125 8.617c3.965 6.666 11.609 10.817 19.92 10.817h50.234c17.153 0 31.058-12.689 31.058-28.342v-27.787c-.002-15.653-13.907-28.342-31.06-28.342z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.412 148.713h-86.412-86.412c-17.595 0-31.859 14.264-31.859 31.859v31.235c0 17.595 14.264 31.859 31.859 31.859h51.53c8.525 0 16.367-4.666 20.434-12.159l5.257-9.686c3.958-7.292 14.425-7.292 18.382 0l5.257 9.686c4.067 7.493 11.909 12.159 20.434 12.159h51.53c17.595 0 31.859-14.264 31.859-31.859v-31.235c.001-17.595-14.263-31.859-31.859-31.859zm13.853 61.236c0 8.776-7.778 15.917-17.338 15.917h-49.452c-3.331 0-6.387-1.67-7.976-4.357l-5.046-8.534c-4.075-6.892-11.912-11.174-20.454-11.174s-16.379 4.281-20.454 11.174l-5.045 8.534c-1.589 2.688-4.645 4.357-7.976 4.357h-49.452c-9.56 0-17.338-7.141-17.338-15.917v-27.519c0-8.776 7.778-15.917 17.338-15.917h165.855c9.56 0 17.338 7.141 17.338 15.917z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.265 198.494v11.456c0 8.776-7.778 15.917-17.338 15.917h-49.452c-3.331 0-6.387-1.67-7.976-4.357l-5.046-8.533c-4.075-6.892-11.912-11.174-20.454-11.174s-16.379 4.281-20.454 11.174l-5.045 8.533c-1.589 2.687-4.645 4.357-7.976 4.357h-49.452c-9.56 0-17.337-7.141-17.337-15.917v-11.456h-18.007v13.314c0 17.595 14.264 31.859 31.859 31.859h51.53c8.525 0 16.367-4.666 20.434-12.159l5.257-9.686c3.958-7.292 14.425-7.292 18.382 0l5.257 9.686c4.067 7.493 11.909 12.159 20.434 12.159h51.53c17.595 0 31.859-14.264 31.859-31.859v-13.313h-18.005z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 291.041,
    fill: "url(#SVGID_20_)",
    r: 35.664
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 291.041,
    fill: "url(#SVGID_21_)",
    r: 23.946
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.807 309.404h-46.015c-57.674 0-104.595-46.922-104.595-104.595v-128.942c0-10.255 8.313-18.568 18.568-18.568s18.568 8.313 18.568 18.568v128.942c0 37.197 30.262 67.46 67.46 67.46h46.015c10.255 0 18.568 8.313 18.568 18.568-.001 10.254-8.314 18.567-18.569 18.567z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.197 95.164h37.135v21.151h-37.135z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.197 89.382 37.135 37.135v-42.943h-37.135z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.954 89.355h35.62c3.647 0 6.604-2.957 6.604-6.604 0-3.647-2.957-6.604-6.604-6.604h-35.62c-3.647 0-6.604 2.957-6.604 6.604.001 3.647 2.957 6.604 6.604 6.604z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.197 124.519h37.135v21.151h-37.135z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 400.184c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.887-12.615 47.543 2.427 47.543 26.83v20.6c0 11.267-9.133 20.4-20.4 20.4h-469.2c-11.267 0-20.4-9.133-20.4-20.4v-20.603c0-24.583 27.011-39.597 47.889-26.618z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 400.238v47.167c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-47.167c0-13.59-11.017-24.606-24.606-24.606h-460.788c-13.589 0-24.606 11.016-24.606 24.606z",
    fill: "url(#SVGID_28_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSnorkeling);
export default __webpack_public_path__ + "static/media/icon-snorkeling.7e739d2e9899149335c7ec5eaa06a7e4.svg";
export { ForwardRef as ReactComponent };